// ============================================================================
// Validação da tela de entrada, sem biblioteca (20/09/2026).
//
// Por que existe: o `loginSchema` do zod era a ÚNICA coisa que puxava a
// biblioteca inteira para o pacote de entrada do app — 130 KB para conferir se
// um email tem arroba e se a senha não está vazia. E a tela de entrada é
// exatamente a que não pode ser pesada: é a primeira coisa que a compradora vê,
// e 243 pessoas passaram por ela em 30 dias.
//
// O zod continua no app para o quiz, que é carregado sob demanda e valida
// formas de verdade. Aqui são dois campos.
//
// As mensagens são LITERALMENTE as mesmas de antes, e o teste ao lado compara
// o veredito desta função com o do schema antigo caso a caso — inclusive a
// ordem em que os erros aparecem, porque a tela mostra só o primeiro.
// ============================================================================

/** O mesmo formato que o zod v3 aceita em `z.string().email()`. */
const EMAIL =
  /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9-]*\.)+[A-Z]{2,}$/i;

export type LoginValidation = { ok: true } | { ok: false; message: string };

export function validateLogin(email: string, password: string): LoginValidation {
  // A ordem importa: o formulário mostra apenas a primeira mensagem, e antes
  // o email era checado primeiro porque vinha primeiro no objeto do schema.
  if (!EMAIL.test(email)) return { ok: false, message: 'Invalid email address' };
  if (password.length < 1) return { ok: false, message: 'Password is required' };
  return { ok: true };
}
